export const dataMenus = [
  {
    id: 4,
    name: 'CRÉDITOS',
    route: '/creditos',
    subMenus: [
      {
        id: 42,
        name: 'Procesos',
        route: '/creditos',
        options: [
          {
            id: 421,
            name: 'Etapas',
            route: '/phases',
          },
          {
            smId: 422,
            route: '/formCredits',
            name: 'Solicitud de crédito',
          },
        ],
      },
      {
        id: 43,
        name: 'Reportes',
        route: '/creditos',
        options: [
          {
            id: 431,
            name: 'Lista de créditos',
            route: '/creditos',
          },
        ],
      },
    ],
  },
];

/**
 * Menú según el rol del vendedor (srKey del rol, guardado al iniciar sesión):
 *  - FREELANCE: igual que un auxiliar (la consulta es de solo lectura; lo controla el backend).
 *  - HOUSE (casa comercial): además administra su equipo.
 *  - Cualquier otro rol: el menú de siempre.
 */
export const getMenusByRole = (rolKey?: string | null) => {
  if (rolKey === 'HOUSE') {
    return [
      ...dataMenus,
      {
        id: 5,
        name: 'MI EQUIPO',
        route: '/mi-equipo',
        subMenus: [
          {
            id: 52,
            name: 'Procesos',
            route: '/mi-equipo',
            options: [{ id: 521, route: '/mi-equipo', name: 'Registro de comerciales' }],
          },
        ],
      },
    ];
  }
  return dataMenus;
};
